export const emailDripReviewFormKeys = {
  redirectUrl: "redirectUrl",
};

export const emailDripLearnMore =
  "https://support.exlyapp.com/support/solutions/articles/84000392244-drip-email-campaigns-on-exly";
